export default "__VITE_ASSET__91e69472__"